export default "__VITE_ASSET__CGCMupgc__"